// src/components/EditarRecompensaModal.js

import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';
import { toast } from 'react-toastify';
import Button from './Button';

function EditarRecompensaModal({ recompensa, onClose, onRecompensaActualizada }) {
  const [titulo, setTitulo] = useState('');
  const [puntos, setPuntos] = useState(50);
  const [error, setError] = useState('');

  // Rellenar el formulario cuando se abre el modal
  useEffect(() => {
    if (recompensa) {
      setTitulo(recompensa.titulo);
      setPuntos(recompensa.puntos_necesarios);
    }
  }, [recompensa]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!titulo || puntos <= 0) {
        setError('El título es obligatorio y los puntos deben ser mayor que cero.');
        return;
    }
    try {
      const recompensaActualizada = { 
        titulo, 
        puntos_necesarios: puntos,
        tipo: recompensa.tipo // Mantenemos el tipo original
      };
      await apiClient.put(`/recompensas/${recompensa.id}/`, recompensaActualizada);
      toast.success('¡Recompensa actualizada!');
      onRecompensaActualizada();
      onClose();
    } catch (err) {
      setError('No se pudo actualizar la recompensa.');
      console.error(err);
    }
  };

  if (!recompensa) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold text-principal mb-6">Editar Recompensa 🏆</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 font-bold mb-2">Título de la Recompensa</label>
            <input
              type="text"
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
              placeholder="Ej: Ver una película"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-principal"
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 font-bold mb-2">Puntos Necesarios ✨</label>
            <input
              type="number"
              value={puntos}
              onChange={(e) => setPuntos(e.target.value)}
              min="1"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-principal"
            />
          </div>
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
          <div className="flex justify-end gap-4">
            <Button type="button" variant="secondary" onClick={onClose}>Cancelar</Button>
            <Button type="submit" variant="accent">Guardar Cambios</Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditarRecompensaModal;